const PLACEMENT_RULES = [
  [/sidebar/i, 'sidebar'],
  [/footer/i, 'footer'],
  [/(home|header|hero)/i, 'homepage'],
  [/(event)/i, 'events'],
  [/(creator)/i, 'creators'],
  [/(article|news)/i, 'articles'],
  [/(game|gaming|trivia|leaderboard)/i, 'gaming'],
  [/(music|mixtape|record|radio|playlist|video|media)/i, 'music'],
];

const CANONICAL = new Set([
  'homepage', 'music', 'events', 'creators', 'articles', 'gaming',
  'general', 'native_event', 'sidebar', 'footer',
]);

const NON_PUBLIC_SURFACE_PREFIXES = [
  '/admin',
  '/staff',
  '/creator/dashboard',
  '/creator/settings',
  '/creator/welcome',
  '/creator-onboard',
];

export function publicAdSurfaceAllowed(pathname = '') {
  return !NON_PUBLIC_SURFACE_PREFIXES.some((prefix) => String(pathname).startsWith(prefix));
}

export function canonicalLocalPlacement(placement) {
  const value = String(placement || 'general').trim().toLowerCase();
  if (CANONICAL.has(value)) return value;
  return PLACEMENT_RULES.find(([pattern]) => pattern.test(value))?.[1] || 'general';
}

export function googleCanServe(config, placement, pathname = '') {
  if (!config?.enabled || !config?.publisher_id) return false;
  if (!publicAdSurfaceAllowed(pathname) || String(pathname).startsWith('/odds')) return false;
  if ((config.excluded_pages || []).some((page) => String(pathname).startsWith(page))) return false;
  const placementConfig = config.ad_placements?.[placement];
  const slot = (placementConfig?.enabled && placementConfig?.ad_slot)
    || config.default_ad_slot;
  return Boolean(slot || config.auto_ads);
}

export function chooseAdSource({
  ad,
  isDefault = false,
  googleAvailable = false,
  placement,
  storage = typeof window !== 'undefined' ? window.sessionStorage : null,
}) {
  const paidLocal = Boolean(ad && !isDefault && !ad.is_house_ad);
  if (paidLocal && !googleAvailable) return 'local';
  if (!paidLocal && googleAvailable) return 'google';
  if (!paidLocal) return ad ? 'local' : null;

  const key = `rastyle-ad-rotation:${canonicalLocalPlacement(placement)}`;
  let turn = 0;
  try {
    turn = Number.parseInt(storage?.getItem(key) || '0', 10) || 0;
    storage?.setItem(key, String(turn + 1));
  } catch {
    turn = 0;
  }
  return turn % 2 === 0 ? 'local' : 'google';
}
